/**
 * Glstsho Theme - Helper Utilities
 */

export const $ = (selector, context = document) => context.querySelector(selector);

export const $$ = (selector, context = document) => [...context.querySelectorAll(selector)];

export const debounce = (fn, delay = 300) => {
  let timeoutId;
  return function(...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), delay);
  };
};

export const throttle = (fn, limit = 300) => {
  let inThrottle;
  return function(...args) {
    if (!inThrottle) {
      fn.apply(this, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
};

export const parseJSON = (str, fallback = null) => {
  try {
    return JSON.parse(str);
  } catch {
    return fallback;
  }
};

export const generateId = (prefix = 'glstsho') => {
  return `${prefix}-${Math.random().toString(36).substring(2, 9)}`;
};

export const isElementInViewport = (el, threshold = 0) => {
  const rect = el.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;
  return (
    rect.top <= windowHeight * (1 + threshold) &&
    rect.bottom >= 0 - (windowHeight * threshold) &&
    rect.left <= windowWidth * (1 + threshold) &&
    rect.right >= 0 - (windowWidth * threshold)
  );
};
